export enum CalendarType {
    MONTH = 'month',
    AGENDA = 'agenda',
}
